import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule, CanActivate } from '@angular/router';
import { registerLocaleData } from '@angular/common';

import { HomeComponent } from '../app/pages/home/home.component';
import { PageNotFoundComponent } from '../app/pages/page-not-found/page-not-found.component';
import { LoginComponent } from '../app/pages/Authen/login/login.component';
import { RouteGuardService } from '../app/services/Authen/route-guard.service';

// coop
import { CoopInfoComponent } from '../app/pages/Coop/coop-info/coop-info.component';
import { CoopComponent } from '../app/pages/Coop/coop/coop.component';
import { CoopAssetsComponent } from '../app/pages/Coop/coop-assets/coop-assets.component';
import { CoopMachineComponent } from '../app/pages/Coop/coop-machine/coop-machine.component';
import { CoopInsertComponent } from '../app/pages/Coop/coop-insert/coop-insert.component';
import { CoopProfileComponent } from '../app/pages/Coop/coop-profile/coop-profile.component';

//CMS
import { CmsHomeComponent } from '../app/pages/cms/cms-home/cms-home.component'
import { UserManagementComponent } from '../app/pages/cms/user-management/user-management.component';
import { CreateUserComponent } from '../app/pages/cms/user-management/create-user/create-user.component';
import { EditUserComponent } from '../app/pages/cms/user-management/edit-user/edit-user.component';
import { SatisfactionManagementComponent } from '../app/pages/cms/satisfaction-management/satisfaction-management.component';
import { PageManagementComponent } from '../app/pages/cms/page-management/page-management.component';
import { from } from 'rxjs';

//Agri
import { HomeAgriComponent } from './pages/home-agri/home-agri.component';
import { AgriInsertComponent } from './pages/agri/agri-insert/agri-insert.component';
import { AgriAssetsComponent } from './pages/agri/agri-assets/agri-assets.component';
import { AgriInfoComponent } from './pages/agri/agri-info/agri-info.component';
import { AgriMachineComponent } from './pages/agri/agri-machine/agri-machine.component';
import { AgriProfileComponent } from './pages/agri/agri-profile/agri-profile.component';

const routes: Routes = [
  {
    path: '', component: HomeComponent //Coop
  },
  {
    path: 'Login', component: LoginComponent
  },

  // coop
  {
    path: 'Coop-info/:countryName', component: CoopInfoComponent
  },
  {
    path: 'ProfileCoop', component: CoopProfileComponent
  },
  // {
  //   path: 'Coop', component: CoopComponent
  // },
  {
    path: 'Coop-Assets', component: CoopAssetsComponent
  },
  {
    path: 'Coop-Machine', component: CoopMachineComponent
  },
  {
    path: 'Coop-Insert', component: CoopInsertComponent
  },

  //CMS
  {
    path: 'user-management', component: UserManagementComponent, canActivate: [RouteGuardService]
  },
  {
    path: 'create-user', component: CreateUserComponent, canActivate: [RouteGuardService]
  },
  {
    path: 'edit-user', component: EditUserComponent, canActivate: [RouteGuardService]
  },
  {
    path: 'satisfaction-management', component: SatisfactionManagementComponent, canActivate: [RouteGuardService]
  },
  {
    path: 'page-management', component: PageManagementComponent, canActivate: [RouteGuardService]
  },

  // Agri
  {
    path: 'Agri', component: HomeAgriComponent,
  },
  {
    path: 'Agri-Insert', component: AgriInsertComponent,
  },
  {
    path: 'Agri-Assets', component: AgriAssetsComponent,
  },
  {
    path: 'Agri-Machine', component: AgriMachineComponent,
  },
  {
    path: 'Agri-info/:countryName', component: AgriInfoComponent,
  },
  {
    path: 'ProfileAgri', component: AgriProfileComponent
  },

  // // 404
  // { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

export const RouterComponents = [
  HomeComponent,

  //  Cooperative
  CoopInfoComponent

];
